//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoCard from './InfoCard';

const Info = () => {
  const { t } = useTranslation();
  return (
    <div className="about-info-container">
      <InfoCard title={t('infocard1Title')} text={t('infocard1Text')} />

      <InfoCard title={t('infocard2Title')} text={t('infocard2Text')} />

      <InfoCard title={t('infocard3Title')} text={t('infocard3Text')} />
    </div>
  );
};

export default Info;



// WEBPACK FOOTER //
// ./src/Pages/AboutUs/Info.js